import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence
} from 'firebase/auth';
import { auth } from '../firebase/config';
import { getUserById } from './userService';

// Configurar persistencia de sesión
setPersistence(auth, browserLocalPersistence);

// Login con email y password
export const loginWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const userData = await getUserById(userCredential.user.uid);

    if (!userData.isActive) {
      await signOut(auth);
      throw new Error('Usuario desactivado. Contacta al administrador.');
    }

    return { user: userCredential.user, userData };
  } catch (error) {
    console.error('Error en login:', error);
    throw error;
  }
};

// Logout
export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Error en logout:', error);
    throw error;
  }
};

// Observar cambios en la autenticación
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Obtener usuario actual
export const getCurrentUser = () => {
  return auth.currentUser;
};
